import React, { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "../helper/HwIcon";

const HwPlainSelect = ({ value, options = [], placeholder, onChange, error }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);
  const selected = options.find((o) => String(o.value) === String(value));
  return (
    <div
      ref={ref}
      className={`hw-gsel ${open ? "is-open" : ""} ${error ? "is-error" : ""}`}
    >
      <button
        type="button"
        className="hw-gsel--control"
        onClick={() => setOpen((v) => !v)}
      >
        <span className={`hw-gsel--value ${selected ? "" : "is-placeholder"}`}>
          {selected ? selected.label : placeholder}
        </span>
        <span className="hw-gsel--chevron">
          <ChevronDownIcon />
        </span>
      </button>
      {open ? (
        <ul className="hw-gsel--menu" role="listbox">
          {options.map((o) => (
            <li
              key={o.value}
              role="option"
              aria-selected={String(o.value) === String(value)}
              className={`hw-gsel--option ${
                String(o.value) === String(value) ? "is-selected" : ""
              }`}
              onClick={() => {
                onChange(o.value);
                setOpen(false);
              }}
            >
              <span>{o.label}</span>
              {String(o.value) === String(value) ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12.5l4.5 4.5L19 7"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default HwPlainSelect;
